import React, { useContext } from "react";
//@ts-ignore
import { LocalizationContext } from "react-localize";
import "./CancelErrorModal.sass";
import { MvPrimaryBtn } from "Generic/MvPrimaryBtn";
import moment from "moment";
import MvIcon from "Generic/MvIcon";

type Props = {
    openModal: boolean;
    toggleModal: () => void;
    errorMessage: string;
    id?: string
    scrollY?: boolean;
  };
  
  const CancelErrorModal = ({
    openModal,
    toggleModal,
    id,
    scrollY,
    errorMessage
  }: Props) => {
    const { localize } = useContext(LocalizationContext);
    if (!openModal) {
        return <div />;
      }

      const handleClose = () => {
        toggleModal();
      }

      return (
          <React.Fragment>
              <section
                className={`${!openModal ? "cancel-error-main-overlay hide" : "cancel-error-main-overlay"} ${scrollY ? "scroll-y" : ""}`}
                id={id ? id : ""}
              >
                  <div className="content">
                    <div className="content-icon" onClick={handleClose}>
                        <MvIcon
                            color="#5F5F5F"
                            style={{
                                height: "14px",
                                width: "14px"
                            }}
                            icon={"times"}
                        />
                    </div>
                    <div className="content-title">Error Message</div>
                    <div className="content-body"  dangerouslySetInnerHTML={{ __html: errorMessage}}></div>
                  </div>
              </section>
              <div
                className={!openModal ? "cancel-error-black-overlay hide" : "cancel-error-black-overlay"}
                onClick={toggleModal}
              >
              </div>
          </React.Fragment>
      )
  }

  export default CancelErrorModal;